export const SELF_HOSTED_ROUTE_NAMES = {
  INDEX: 'index',
  NEW: 'new',
  EDIT: 'edit',
  FEATURES: 'features',
  MODELS: 'models',
};

export const SELF_HOSTED_DUO_TABS = {
  SELF_HOSTED_MODELS: 'self-hosted-models',
  AI_FEATURE_SETTINGS: 'ai-feature-settings',
};

export const RELEASE_STATES = {
  GA: 'GA',
  BETA: 'BETA',
  EXPERIMENT: 'EXPERIMENT',
};
